import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Field } from 'formik';
import { QuestionCircle } from 'react-bootstrap-icons';
import { sentencecase } from 'stringcase';

let ValidationInput = ({
  name,
  large,
  type = 'text',
  tooltip,
  label,
  suffix,
  prefix,
  maximumCount,
  onChange = () => {},
  ...props
}) => {
  let showLabel = label !== '';
  return (
    <Field name={name}>
      {({ field, form: { touched, errors } }) => {
        let modified = touched[name];
        let error = errors[name];
        let changeHandler = (event) => {
          let value = event.target.value;
          field.onChange(event);
          onChange(value);
        };
        return (
          <Form.Group className="mb-3">
            {showLabel && (
              <Form.Label className="mb-0">
                {label || sentencecase(name)}{' '}
                {tooltip && (
                  <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>
                    <span className="d-inline-block">
                      <QuestionCircle className="text-primary mb-2" size={12} />
                    </span>
                  </OverlayTrigger>
                )}
              </Form.Label>
            )}
            <InputGroup hasValidation={!suffix}>
              {prefix && (
                <InputGroup.Prepend>
                  <InputGroup.Text>{prefix}</InputGroup.Text>
                </InputGroup.Prepend>
              )}
              <Form.Control
                {...props}
                name={name}
                as={large ? 'textarea' : 'input'}
                type={type}
                {...field}
                onChange={changeHandler}
                isInvalid={!!error && modified}
                data-cy={`input-${name}`}
              />

              {suffix && (
                <InputGroup.Append>
                  <InputGroup.Text>{suffix}</InputGroup.Text>
                </InputGroup.Append>
              )}
              {modified && error && (
                <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
              )}
            </InputGroup>
            {maximumCount && (
              <div className="text-right text-secondary" style={{ fontSize: '0.8rem' }}>
                {field.value.length}/{maximumCount}
              </div>
            )}
          </Form.Group>
        );
      }}
    </Field>
  );
};

export default ValidationInput;
